import Vue from "vue";
import VueRouter from "vue-router";
import Home from '@/views/home/Index.vue'
import Solution from '@/views/solution/Index.vue'
import About from '@/views/about/Index.vue'
import Partner from '@/views/partner/Index.vue'
import Cases from '@/views/cases/Index.vue'
import Experience from '@/views/experience/Index.vue'
import Reservation from '@/views/reservation/Index.vue'

Vue.use(VueRouter);
const routes = [
  {
    path: "/",
    name: "思为科技首页",
    component: Home,
  },
  {
    path: "/solution",
    name: "解决方案",
    component: Solution,
  },
  {
    path: "/solution/group",
    name: "集团型客户",
    component: Solution,
  },
  {
    path: "/solution/city",
    name: "区域型客户",
    component: Solution,
  },
  {
    path: "/solution/project",
    name: "项目型客户",
    component: Solution,
  },
  {
    path: "/cases",
    name: "成功案例",
    component: Cases,
  },
  {
    path: '/about',
    name: '关于我们',
    component: About,
  },
  {
    path: '/about',
    name: '关于思为',
    component: About
  },
  {
    path: '/partner',
    name: '合作伙伴',
    component: Partner
  },
  {
    path: '/experience',
    name: '立即体验',
    component: Experience
  },
  {
    path: '/reservation',
    name: 'reservation',
    component: Reservation
  }
]

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
})

export default router;
